import * as React from 'react'
import { SVGProps } from 'react'
const SvgGameController = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M21.914 11.664c-.862-3.9-2.142-6.386-4.192-6.992A4.288 4.288 0 0 0 16.5 4.5c-1.26 0-2.255.75-4.5.75S8.758 4.5 7.5 4.5a4.64 4.64 0 0 0-1.275.172c-2.053.606-3.322 3.095-4.194 6.992-.89 3.98-.73 7.125 1.011 7.729 1.22.422 2.309-.45 3.341-1.735 1.172-1.462 2.615-1.912 5.617-1.912 3.001 0 4.388.45 5.562 1.912 1.031 1.285 2.161 2.147 3.348 1.742 1.922-.656 1.895-3.709 1.004-7.736Z'
      stroke={props.color ?? '#D64D8A'}
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d='M13.688 11.438a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874ZM15.75 13.5a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874ZM15.75 9.375a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875ZM17.813 11.438a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874Z'
      fill={props.color ?? '#D64D8A'}
    />
    <path
      d='M7.5 8.25v4.5m2.25-2.25h-4.5'
      stroke={props.color ?? '#D64D8A'}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
export default SvgGameController
